import {NotificationMap} from './notificattion.action';

const intialNotificationState = {
    notificationList:{
        records: [],
        recordsTotal: 0
    },
    selectedItem : {},
    notificationLimit: 10,
    notificationBatch: 0,
    isReloading: false
}

export const notificationReducer = (state = intialNotificationState, action) => {
    switch (action.type) {
        case NotificationMap.FETCH_NOTIFICATION_START: {
            return {
                ...state,
                isReloading: true,
            }
        }
        case NotificationMap.FETCH_NOTIFICATION_FAIL: {
            return {
                ...state,
                isReloading: false,
            }
        }

        case NotificationMap.FETCH_NOTIFICATION_SUCCESS: {
            return {
                ...state,
                notificationList: action.payload,
                isReloading: false
            }
        }
        
        case NotificationMap.UPDATE_NOTIFICATION_STATUS_START: {
            return {
                ...state,
                selectedItem: action.payload
            }
        }

        case NotificationMap.UPDATE_NOTIFICATION_STATUS_SUCCESS:
        case NotificationMap.UPDATE_NOTIFICATION_STATUS_ERROR: {        
            return {
                ...state,
                selectedItem: {}
            }
        }

        case NotificationMap.NOTIFICATION_BATCH_NUMBER: {
            return {
                ...state,
                notificationBatch: action.payload
            }
        }
    
        default:
            return {
                ...state,
            }
    }
}

export default notificationReducer;